<div class="flex flex-col" *transloco="let t">
  <div class="flex max-w-[75rem] flex-col gap-4 px-4">
    @let preset = strategy()?.audiencePreset;
    @if (preset && allowPreset()) {
      <app-dsp-audience-preset-selector
        [class.disabled]="isUpdatingAudiences()"
        [audiencePreset]="audiencePresetControl.value"
        [currentSmartAudiencePreset]="preset"
        (audiencePresetChange)="audiencePresetControl.setValue($event)"
      />
    }

    @if (audiencePresetControl.value === StrategyDspAudiencePreset.MANUAL) {
      <div class="flex flex-col">
        <div class="flex flex-col rounded-lg border p-4">
          <div class="flex items-center">
            <h4>{{ t("common.audiences") }}</h4>
            <div class="flex flex-1 justify-end">
              <button
                iButton
                variant="secondary"
                testId="btn-edit-dsp-audiences"
                [disabled]="isReadOnly()"
                (click)="editAudiences(StrategyDspAudienceType.WHITELIST)"
              >
                <IIcon name="edit" />
                {{ t("common.edit") }}
              </button>
            </div>
          </div>
          <div>
            <app-dsp-audience-list
              [audiences]="whitelistedAudiences()"
              [audienceType]="StrategyDspAudienceType.WHITELIST"
            />
          </div>
          <div class="mt-8 flex items-center">
            <h4>{{ t("dsp-strategy-page.audience_blacklist") }}</h4>
            @if (hasBlacklistedAudiences()) {
              <div class="flex flex-1 justify-end">
                <button
                  iButton
                  variant="secondary"
                  testId="btn-edit-dsp-audiences"
                  [disabled]="isReadOnly()"
                  (click)="editAudiences(StrategyDspAudienceType.BLACKLIST)"
                >
                  <IIcon name="edit" />
                  {{ t("common.edit") }}
                </button>
              </div>
            }
          </div>
          <div class="max-h-[20rem] overflow-x-clip overflow-y-auto">
            <app-dsp-audience-list
              [audiences]="blacklistedAudiences()"
              [audienceType]="StrategyDspAudienceType.BLACKLIST"
            />
            @if (!hasBlacklistedAudiences()) {
              <div class="flex px-1 py-4">
                <button
                  iButton
                  variant="secondary"
                  (click)="editAudiences(StrategyDspAudienceType.BLACKLIST)"
                  [disabled]="isReadOnly()"
                >
                  <IIcon name="plus" />
                  {{ t("dsp-audiences.add_audiences") }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="flex max-w-192 flex-col gap-4">
        <app-dsp-smart-audience-selector
          [selectedPreset]="audiencePresetControl.value"
          (selectedPresetChange)="audiencePresetControl.setValue($event)"
        />
        @let hasModifiedAudiencePreset = this.strategy()?.audiencePreset !== this.audiencePresetControl.value;
        <div class="flex justify-end">
          <button
            iButton
            [disabled]="!hasModifiedAudiencePreset || isUpdatingAudiences() || isReadOnly()"
            [loading]="isUpdatingAudiences()"
            (click)="saveSmartAudienceSelection()"
          >
            {{ t("common.save") }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
